import React from "react";
import { Link } from "react-router-dom";
import { clsx } from "clsx";

function ButtonInternalLink({
  children,
  href,
  secondary,
  outline,
  ghost,
  className,
}) {
  return (
    <Link
      to={href}
      className={clsx(
        "group relative flex items-center justify-center gap-2 rounded-xl text-sm px-6 py-2.5 text-center font-bold transition-all duration-300",
        "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500 active:scale-[0.97]",
        {
          // Primary (Default)
          "bg-primary-600 text-white shadow-lg shadow-primary-500/20 hover:bg-primary-500 hover:shadow-primary-500/30":
            !secondary && !outline && !ghost,
          // Secondary
          "bg-slate-800 text-white shadow-lg shadow-slate-900/10 hover:bg-slate-700 hover:shadow-slate-900/20":
            secondary && !outline && !ghost,
          // Outline
          "bg-transparent border-2 border-slate-200 text-slate-600 hover:border-primary-500 hover:text-primary-600 hover:bg-primary-50/50":
            outline,
          // Ghost
          "bg-transparent text-slate-500 hover:bg-slate-100 hover:text-slate-900":
            ghost,
        },
        className,
      )}
    >
      <span className="relative z-10">{children}</span>
    </Link>
  );
}

export default ButtonInternalLink;
